import React from 'react';

// import { TrayButton } from '../shared/components/Tray';
// import { useUIState } from '../shared/contexts/UIStateProvider';
// import { useChat } from '../shared/contexts/ChatProvider';
// import { CHAT_ASIDE } from './ChatAside';
// import { TRANSCRIPTION_ASIDE } from './TranscriptionAside';

// const IconChat = require('!!@svgr/webpack!../shared/icons/chat-md.svg').default;
// const IconCaptions = require('!!@svgr/webpack!../shared/icons/captions.svg').default;

export const Tray = () => {

  return (<>
{/*
    <TrayButton
      label="Chat"
      green={isChat}
      bubble={hasNewMessages}
      onClick={() => {
        toggleAside(CHAT_ASIDE);
      }}
    >
      <IconChat />
    </TrayButton>
*/}
{/*
    <TrayButton
      label="Captions"
      green={isCaptions}
      onClick={() => {
        toggleAside(TRANSCRIPTION_ASIDE);
      }}
    >
      <IconCaptions />
    </TrayButton> */}
  </>);
};
